import { FormControl, Grid, Select, Table, TableBody, TableCell, TableRow
    , TextField, Typography, IconButton, InputLabel, Box } from '@mui/material'
import { AddCircle as IconAddCircle, Delete as IconDelete } from "@mui/icons-material";
import api from "../services/api";
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    addPersonaDocumento, removePersonaDocumento, setDatoPersonaDocumento
    , setPersonaDocumentos, setTiposDocumentos, setValidations, initPersonDocument, defaultPersonaDocumentos
} from '../redux/personDocumentSlice'
import DialogYesNo from './DialogYesNo'
import { FormHelperText as HelperText } from '@mui/material';
import * as personaService from "../services/personaService";
import * as catalogoService from "../services/catalogoService";

const PersonDocument = (props) => {
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;

    useEffect(() => {
        dispatch(initPersonDocument({ sliceKey }));
    }, [dispatch, sliceKey]);

    const personaDocumentos = useSelector((state) => state.personDocument[sliceKey]?.personaDocumentos)
    const tiposDocumentos = useSelector((state) => state.personDocument[sliceKey]?.tiposDocumentos)
    const validate = useSelector((state) => state.personDocument[sliceKey]?.validationActive);

    const [openDialogDelete, setOpenDialogDelete] = useState(false)
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); }
    const [selectNumero, setSelectNumero] = useState(null);
    const [selectId, setSelectId] = useState(null);
    const [numeroDocumentoFocus, setNumeroDocumentoFocus] = useState(null);
    const [onlyOneTypeDocument, setOnlyOneTypeDocument] = useState(false);
    const [numeroDocumentoExistente, setNumeroDocumentoExistente] = useState(false);
    const [typeDocumentAlReadyExists, setTypeDocumentAlReadyExists] = useState("");
    const [dniWith8Digits, setDNIWith8Digits] = useState(false);
    const [anyDocumentAtLeast3Digits, setAnyDocumentAtLeast3Digits] = useState(false);

    var validation = useMemo(() => ({
        AtLeastOneDocument: {
            error: personaDocumentos?.length == 1
                // && personaDocumentos[0].id == 0
                &&
                (
                    personaDocumentos[0]?.idTipoDocumento == 0
                    || personaDocumentos[0]?.numeroDocumento == ""
                ),
            message: "Debe haber por lo menos un documento",
        },
        DNIWith8Digits: {
            error: dniWith8Digits,
            message: "El DNI debe tener 8 digitos",
        },
        DocumentAlReadyExists: {
            error: numeroDocumentoExistente,
            message: "El número de documento " + typeDocumentAlReadyExists + " ya existe"
        },
        OnlyOneTypeDocument: {
            error: onlyOneTypeDocument,
            message: "Sólo puede existir 1 de cada tipo de documento"
        },
        AnyDocumentAtLeast3Digits: {
            error: anyDocumentAtLeast3Digits,
            message: "Un documento debe tener por lo menos 3 dígitos",
        },
    }), [personaDocumentos, dniWith8Digits, numeroDocumentoExistente, onlyOneTypeDocument, anyDocumentAtLeast3Digits]);

    const setItemValue = (numero, name, value) => {
        dispatch(setDatoPersonaDocumento({sliceKey: sliceKey, numero: numero, name: name, value: value}))
    }

    const fetchPersonaDocumentos = useCallback(async () => {
        const response = await personaService.getsPersonaDocumentoView(props.id);
        if (response == null || response.length == 0)
            dispatch(setPersonaDocumentos({sliceKey: sliceKey, data: defaultPersonaDocumentos}));
        else
            dispatch(setPersonaDocumentos({sliceKey: sliceKey, data: response}));
    }, [dispatch, sliceKey, props.id])

    const fetchTiposDocumentos = useCallback(async () => {
        const response = await catalogoService.getCatalogosByPadre(5)
        dispatch(setTiposDocumentos({sliceKey: sliceKey, data: response}));
    }, [])

    useEffect(() => {
        fetchPersonaDocumentos();
        fetchTiposDocumentos();
        // dispatch(setValidations({sliceKey: sliceKey, message: messagesValidation()}));
    }, [fetchPersonaDocumentos, fetchTiposDocumentos])

    const validationMessages = useMemo(() => {
        const messages = []

        Object.keys(validation).forEach((key) => {
            if (validation[key].error) {
                messages.push(validation[key].message)
            }
        })

        return messages
    }, [validation])

    const prevValidationMessages = React.useRef()

    useEffect(() => {
        if (JSON.stringify(prevValidationMessages.current) !== JSON.stringify(validationMessages)) {
            prevValidationMessages.current = validationMessages
            dispatch(setValidations({
                sliceKey,
                message: validationMessages
            }))
        }
    }, [dispatch, sliceKey, validationMessages])

    // useEffect(() => {
    //     dispatch(setValidations({sliceKey: sliceKey, message: messagesValidation()}));
    // }, [personaDocumentos, numeroDocumentoExistente])

    useEffect(() => {
        validateUniqueDocumentTypes()
        validateAnyDocumentAtLeast3Digits()
    }, [personaDocumentos])

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    const deletePersonaDocumento = async () => {
        await personaService.deletePersonaDocumento(props.id, selectNumero)
        dispatch(removePersonaDocumento({sliceKey: sliceKey, numero: selectNumero}));
    }
    const buscarDocumentoExistente = async (idTipoDocumento, numeroDocumento) => {
        const document = await personaService.getsPersonaDocumentoByTipoYNumeroView(idTipoDocumento, numeroDocumento)
        setNumeroDocumentoExistente(document.length > 0);
        // api.get("/PersonaDocumento/GetPersonaDocumentoByTipoYNumero?idTipoDocumento="
        //     + idTipoDocumento + "&numeroDocumento=" + numeroDocumento)
        // .then(document => {
        //     setNumeroDocumentoExistente(document.data.data.length > 0);
        // })
        // .catch((err) => {
        //     console.log("Err: ", err)
        // });
    }

    const validateDNIWith8Digits = (idTipoDocumento, numeroDocumento) => {
        setDNIWith8Digits(idTipoDocumento == 6 && numeroDocumento != null && numeroDocumento.length != 8)
    }

    const validateAnyDocumentAtLeast3Digits = () => {
        var countDocumentsWithLess3Digits = 0
        var DNIWithout8Digits = false

        for (let i = 0; i < personaDocumentos?.length; i++) {
            var document = personaDocumentos[i];

            if (document.idTipoDocumento > 0 && document.numeroDocumento.length < 3) countDocumentsWithLess3Digits++;
            if (document.idTipoDocumento == 6 && document.numeroDocumento.length != 8) DNIWithout8Digits = true;
            // if (countDocumentsWithLess3Digits > 0) i = personaDocumentos.length
        }

        const newAnyDoc = !!countDocumentsWithLess3Digits
        const newDNI = DNIWithout8Digits
        setAnyDocumentAtLeast3Digits(prev => prev !== newAnyDoc ? newAnyDoc : prev)
        setDNIWith8Digits(prev => prev !== newDNI ? newDNI : prev)

        console.log(countDocumentsWithLess3Digits)

        // setAnyDocumentAtLeast3Digits(!!countDocumentsWithLess3Digits)
        // setDNIWith8Digits(DNIWithout8Digits)
    }

    const validateUniqueDocumentTypes = () => {
        var countDuplicateDocumentTypes = 0

        for (let i = 0; i < personaDocumentos?.length; i++) {
            for (let j = i + 1; j < personaDocumentos?.length; j++) {
                if (personaDocumentos[i].idTipoDocumento == personaDocumentos[j].idTipoDocumento) {
                    countDuplicateDocumentTypes++
                    break
                }
                // if (countDuplicateDocumentTypes > 0) j = personaDocumentos.length
            }
            // if (countDuplicateDocumentTypes > 0) i = personaDocumentos.length
            if (countDuplicateDocumentTypes > 0) break
        }

        const newValue = !!countDuplicateDocumentTypes

        setOnlyOneTypeDocument(prev => prev !== newValue ? newValue : prev)
        // setOnlyOneTypeDocument(!!countDuplicateDocumentTypes)
    }

    return (
        <Grid container>
            <Grid item>
                <Typography variant="h7">
                    <Box sx={{ fontWeight: 'bold' }} padding={0}>
                        {"Documentos (" + (personaDocumentos?.length || 0) + ")"}
                    </Box>
                </Typography>
            </Grid>
            <Grid item>
                <IconButton size="small" aria-label="Agregar Direccion" style={{height: 10}} onClick={() => {
                    dispatch(addPersonaDocumento(sliceKey));
                }}>
                    <IconAddCircle />
                </IconButton>
            </Grid>
            <Grid container>
                {/* {JSON.stringify(validation)} */}
                {/* {JSON.stringify(numeroDocumentoExistente)} */}
                <Table size="small">
                    <TableBody>
                        {personaDocumentos?.map((row, index) => (
                            <TableRow key={row.numero} sx={(theme) => ({
                                backgroundColor: index % 2 === 1 ? theme.palette.action.selected : 'inherit',
                                "&:last-child td, &:last-child th": { borderRadius: "0.5em" },
                            })}>
                                <TableCell>
                                    <Grid container spacing={1} padding={0}>
                                        <Grid item xs={8} sm={5}>
                                            <FormControl required fullWidth>
                                                <InputLabel htmlFor="input-tipodocumento">Tipo</InputLabel>
                                                <Select
                                                    native
                                                    label="Tipo"
                                                    value={row.idTipoDocumento || 0}
                                                    fullWidth
                                                    onChange={(event, newValue) => {
                                                        if (event.target.value !== row.idTipoDocumento && row.numeroDocumento != null && row.numeroDocumento.length >= 6) {
                                                            buscarDocumentoExistente(event.target.value, row.numeroDocumento)
                                                        }

                                                        validateDNIWith8Digits(event.target.value, row.numeroDocumento)

                                                        if (event.target.value == 0) setNumeroDocumentoExistente(false)
                                                        if (event.target.value == 0) setOnlyOneTypeDocument(false)
                                                        if (event.target.value == 0) setDNIWith8Digits(false)

                                                        var id = event.nativeEvent.target.selectedIndex;

                                                        setItemValue(row.numero, "idTipoDocumento", event.target.value)
                                                        setItemValue(row.numero, "tipoDocumento", event.nativeEvent.target[id].text)
                                                        
                                                        // validateUniqueDocumentTypes()
                                                        // validateAnyDocumentAtLeast3Digits()
                                                    }}
                                                    inputProps={{
                                                        name: 'idTipoDocumento',
                                                        id: 'input-tipodocumento',
                                                    }}
                                                    size="small"
                                                >
                                                    <option key={0} value={0}>{"(Seleccione)"}</option>
                                                    {tiposDocumentos.map((row) => (
                                                        <option key={row.id} value={row.id}>{row.descripcion}</option>
                                                    ))}
                                                </Select>
                                                {/* <HelperText>
                                                    {validate.DNIWith8Digits && validation.DNIWith8Digits.error ? validation.DNIWith8Digits.message : ""}
                                                </HelperText>
                                                <HelperText>
                                                    {validate.AnyDocumentAtLeast3Digits && validation.AnyDocumentAtLeast3Digits.error ? validation.AnyDocumentAtLeast3Digits.message : ""}
                                                </HelperText> */}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={7}>
                                            <Box display="flex" alignItems="center" gap={0}>
                                                <TextField
                                                    required
                                                    name="numeroDocumento"
                                                    label="Numero"
                                                    value={row.numeroDocumento || ""}
                                                    fullWidth
                                                    onFocus={(event) => {
                                                        setNumeroDocumentoFocus(event.target.value)
                                                    }}
                                                    onChange={(event) => {
                                                        setItemValue(row.numero, "numeroDocumento", event.target.value)

                                                        // validateUniqueDocumentTypes()
                                                        validateDNIWith8Digits(row.idTipoDocumento, event.target.value)
                                                        // validateAnyDocumentAtLeast3Digits()
                                                    }}
                                                    onBlur={(event) => {
                                                        if (row.idTipoDocumento > 0 && event.target.value.length >= 6 && event.target.value !== numeroDocumentoFocus) {
                                                            setTypeDocumentAlReadyExists(row.tipoDocumento)

                                                            buscarDocumentoExistente(row.idTipoDocumento, event.target.value)
                                                        }
                                                        else {
                                                            if (event.target.value.length < 6) setNumeroDocumentoExistente(false)
                                                        }

                                                        setItemValue(row.numero, "numeroDocumento", event.target.value)

                                                        // validateAnyDocumentAtLeast3Digits()
                                                        // dispatch(setValidations({sliceKey: sliceKey, message: messagesValidation()}));
                                                    }}
                                                    size="small"
                                                // error={
                                                //     (validate.DocumentAlReadyExists && validation.DocumentAlReadyExists.error)
                                                //     || (validate.AnyDocumentAtLeast3Digits && validation.AnyDocumentAtLeast3Digits.error)
                                                // }
                                                // helperText={
                                                //     validate.DocumentAlReadyExists && validation.DocumentAlReadyExists.error ? validation.DocumentAlReadyExists.message : ""
                                                // }
                                                />
                                                <IconButton aria-label="delete" onClick={() => {
                                                    if (row.idPersona > 0) {
                                                        setSelectId(row.id);
                                                        setSelectNumero(row.numero);
                                                        setOpenDialogDelete(true);
                                                    }
                                                    else {
                                                        dispatch(removePersonaDocumento({sliceKey: sliceKey, numero: row.numero}));
                                                    }

                                                }}>
                                                    <IconDelete />
                                                </IconButton>

                                            </Box>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <FormControl required fullWidth sx={{ mt: 0, mb: 0, p: 0 }}
                    error={
                        (validate?.AtLeastOneDocument && validation.AtLeastOneDocument.error)
                        || (validate?.OnlyOneTypeDocument && validation.OnlyOneTypeDocument.error)
                        || (validate?.DNIWith8Digits && validation.DNIWith8Digits.error)
                        || (validate?.AnyDocumentAtLeast3Digits && validation.AnyDocumentAtLeast3Digits.error)
                        || (validate?.DocumentAlReadyExists && validation.DocumentAlReadyExists.error)
                    }>

                    <HelperText>
                        {validate?.AtLeastOneDocument && validation.AtLeastOneDocument.error ? validation.AtLeastOneDocument.message : ""}
                    </HelperText>
                    <HelperText>
                        {validate?.OnlyOneTypeDocument && validation.OnlyOneTypeDocument.error ? validation.OnlyOneTypeDocument.message : ""}
                    </HelperText>
                    <HelperText>
                        {validate?.DNIWith8Digits && validation.DNIWith8Digits.error ? validation.DNIWith8Digits.message : ""}
                    </HelperText>
                    <HelperText>
                        {validate?.AnyDocumentAtLeast3Digits && validation.AnyDocumentAtLeast3Digits.error ? validation.AnyDocumentAtLeast3Digits.message : ""}
                    </HelperText>
                    <HelperText>
                        {validate?.DocumentAlReadyExists && validation.DocumentAlReadyExists.error ? validation.DocumentAlReadyExists.message : ""}
                    </HelperText>
                </FormControl>
            </Grid>
            <DialogYesNo
                open={openDialogDelete}
                openClose={openCloseDialogDelete}
                setYes={deletePersonaDocumento}
                setNo={() => { return }}
                titulo={"Borrar documento"}
                texto={"Esta seguro de borrar el documento?"}
            ></DialogYesNo>
        </Grid>
    )
}

export default PersonDocument;
